import { useMemo } from "react";
import dayjs from "dayjs";

import { userState } from "../../../../interface/MainInterface";
import EventUserScrollList, { EventUserScrollColumn, compareApplyDtm } from "./EventUserScrollList";

interface propsType {
  userState: userState;
  channelInfo: any;
  eventInfo: any;
  callback: any;
}

const columns: EventUserScrollColumn[] = [
  {
    field: "user_id",
    headerName: "아이디",
  },
  {
    field: "cust_no",
    headerName: "고객번호",
  },
  {
    field: "apply_dtm",
    headerName: "응모시간",
    renderCell: (row: any) => dayjs(row.apply_dtm).format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    field: "ofrNm",
    headerName: "경품명",
  },
];

const LiveEventWinnerList = (props: propsType) => {
  // 응모자 목록과 같은 기준(응모시간 오름차순)으로 보여준다
  const winnerList = useMemo(
    () => [...(props.eventInfo.draw_result || [])].sort(compareApplyDtm),
    [props.eventInfo.draw_result]
  );

  return (
    <EventUserScrollList
      key={props.eventInfo.sk}
      rows={winnerList}
      columns={columns}
      emptyText="당첨자가 없습니다."
      onRowClick={(row) => props.callback({ command: "select_row", info: row })}
    />
  );
};

export default LiveEventWinnerList;
